import {
  alphaOnly,
  dateValidator,
  digits,
  digitsAndSpace,
  sexValidator,
  speciesCodeValidator,
  ringSizeValidation,
  localityValidation
} from "../Validations/MergeValidators";

const DataBaseValidationResighting = (tableApi, data, setSnackBar) => {
  let mergeAllow = true;
  let warnUser = false;
  let errorMessages = [];

  const friendlyMessages = {
    ringNo: {
      empty: "Ring Number is required.",
      invalid: "Ring Number must contain only digits."
    },
    ringSize: {
      empty: "Ring Size is required.",
      invalid: "Ring Size is not valid."
    },
    speciesCode: {
      empty: "Species Code is required.",
      invalid: "Species Code is invalid."
    },
    scientificName: {
      empty: "Scientific Name is required.",
      invalid: "Scientific Name must contain only alphabets."
    },
    date: {
      empty: "Date is required.",
      invalid: "Date format is invalid. Expected format: DD-Mon-YYYY."
    },
    dateOfRinging: {
      empty: "Date of Ringing is required.",
      invalid: "Date of Ringing format is invalid. Expected format: DD-Mon-YYYY."
    },
    dateOfRecovery: {
      empty: "Date of Recovery is required.",
      invalid: "Date of Recovery format is invalid. Expected format: DD-Mon-YYYY."
    },
    placeOfRecovery: {
      missing: "Place of Recovery is required.",
      empty: "Place of Recovery cannot be empty."
    }
  };


  for (let index in data) {
    const row = data[index];
    const objectKeys = Object.keys(row);
    const rowNo = parseInt(index) + 1;

    /* =========================
       REQUIRED / HARD VALIDATION
       ========================= */

    // Ring No
    if (!objectKeys.includes("Ring No")) {
      errorMessages.push(`Row ${rowNo} : Ring No Missing`);
      tableApi.selectCell(rowNo - 1, "Ring No");
      mergeAllow = false;
    } else {
      console.log("Ring No : ", row["Ring No"]);
      let ringNo;
      if(typeof row["Ring No"] === "string") {
        ringNo = (row["Ring No"] || "").trim();
      } else {
        ringNo = row["Ring No"];
      }
      // const ringNo = (row["Ring No"] || "").trim();
      if (!ringNo) {
        errorMessages.push(`Row ${rowNo} : ${friendlyMessages.ringNo.empty}`);
        tableApi.selectCell(rowNo - 1, "Ring No");
        mergeAllow = false;
      } else if (digits(ringNo)) {
        errorMessages.push(`Row ${rowNo} : ${friendlyMessages.ringNo.invalid}`);
        tableApi.selectCell(rowNo - 1, "Ring No");
        mergeAllow = false;
      }

      // Ring Size - check both "Ring Size" and "RingSize" variations
      const ringSizeKey = objectKeys.find(key => 
        key === "Ring Size" || key === "RingSize" || key === "Ring size"
      );
      if (!ringSizeKey) {
        errorMessages.push(`Row ${rowNo} : Ring Size Missing`);
        // Try to find column by different possible names
        let ringSizeCol = tableApi.propToCol("Ring Size");
        if (ringSizeCol === -1) ringSizeCol = tableApi.propToCol("RingSize");
        if (ringSizeCol !== -1) tableApi.selectCell(rowNo - 1, ringSizeCol);
        mergeAllow = false;
      } else {
        const ringSize = (row[ringSizeKey] || "").trim();
        const validRingSizes = ["A", "AB", "B", "C", "F", "AA", "BC", "G", "K", "L", "M", "YZ", "Z", "NA", ""];
        if (!ringSize) {
          errorMessages.push(`Row ${rowNo} : ${friendlyMessages.ringSize.empty}`);
          let ringSizeCol = tableApi.propToCol(ringSizeKey);
          if (ringSizeCol === -1) ringSizeCol = tableApi.propToCol("Ring Size");
          if (ringSizeCol !== -1) tableApi.selectCell(rowNo - 1, ringSizeCol);
          mergeAllow = false;
        } else if (!ringSizeValidation(ringSize)) {
          errorMessages.push(`Row ${rowNo} : ${friendlyMessages.ringSize.invalid}`);
          let ringSizeCol = tableApi.propToCol(ringSizeKey);
          if (ringSizeCol === -1) ringSizeCol = tableApi.propToCol("Ring Size");
          if (ringSizeCol !== -1) tableApi.selectCell(rowNo - 1, ringSizeCol);
          mergeAllow = false;
        } else if (!validRingSizes.includes(ringSize)) {
          // Check if value is in allowed dropdown options - this is the key validation
          errorMessages.push(`Row ${rowNo} : Ring Size "${ringSize}" is not a valid option. Allowed values: ${validRingSizes.filter(v => v !== "").join(", ")}`);
          let ringSizeCol = tableApi.propToCol(ringSizeKey);
          if (ringSizeCol === -1) ringSizeCol = tableApi.propToCol("Ring Size");
          if (ringSizeCol !== -1) tableApi.selectCell(rowNo - 1, ringSizeCol);
          mergeAllow = false;
        }
      }

      // Species Code
      if (!objectKeys.includes("Species Code")) {
        errorMessages.push(`Row ${rowNo} : Species Code Missing`);
        tableApi.selectCell(rowNo - 1, "Species Code");
        mergeAllow = false;
      } else {
        const speciesCode = (row["Species Code"] || "").trim();
        if (!speciesCode) {
          errorMessages.push(`Row ${rowNo} : ${friendlyMessages.speciesCode.empty}`);
          tableApi.selectCell(rowNo - 1, "Species Code");
          mergeAllow = false;
        } else if (speciesCodeValidator(speciesCode)) {
          errorMessages.push(`Row ${rowNo} : ${friendlyMessages.speciesCode.invalid}`);
          tableApi.selectCell(rowNo - 1, "Species Code");
          mergeAllow = false;
        }
      }

      // Scientific Name
      if (!objectKeys.includes("Scientific Name")) {
        errorMessages.push(`Row ${rowNo} : Scientific Name Missing`);
        tableApi.selectCell(rowNo - 1, "Scientific Name");
        mergeAllow = false;
      } else {
        const scientificName = (row["Scientific Name"] || "").trim();
        if (!scientificName) {
          errorMessages.push(`Row ${rowNo} : ${friendlyMessages.scientificName.empty}`);
          tableApi.selectCell(rowNo - 1, "Scientific Name");
          mergeAllow = false;
        } else if (alphaOnly(scientificName)) {
          errorMessages.push(`Row ${rowNo} : ${friendlyMessages.scientificName.invalid}`);
          tableApi.selectCell(rowNo - 1, "Scientific Name");
          mergeAllow = false;
        }
      }

      // Date of Recovery
      if (!objectKeys.includes("Date of Recovery")) {
        errorMessages.push(`Row ${rowNo} : Date of Recovery Missing`);
        tableApi.selectCell(rowNo - 1, "Date of Recovery");
        mergeAllow = false;
      } else {
        const dateOfRecovery = (row["Date of Recovery"] || "").trim();
        if (!dateOfRecovery) {
          errorMessages.push(`Row ${rowNo} : ${friendlyMessages.dateOfRecovery.empty}`);
          tableApi.selectCell(rowNo - 1, "Date of Recovery");
          mergeAllow = false;
        } else if (dateValidator(dateOfRecovery)) {
          errorMessages.push(`Row ${rowNo} : ${friendlyMessages.dateOfRecovery.invalid}`);
          tableApi.selectCell(rowNo - 1, "Date of Recovery");
          mergeAllow = false;
        }
      }

      // Date of Ringing
      if (objectKeys.includes("Date of Ringing")) {
        const dateOfRinging = (row["Date of Ringing"] || "").trim();
        if (dateOfRinging) {
          if (dateValidator(dateOfRinging)) {
            errorMessages.push(`Row ${rowNo} : ${friendlyMessages.dateOfRinging.invalid}`);
            tableApi.selectCell(rowNo - 1, "Date of Ringing");
            mergeAllow = false;
          }
        }
      }


      /* =========================
         LOCATION VALIDATION
         ========================= */

      if (!objectKeys.includes("Place of Recovery")) {
        errorMessages.push(`Row ${rowNo} : Place of Recovery Missing`);
        tableApi.selectCell(rowNo - 1, "Place of Recovery");
        mergeAllow = false;
      } else {
        const placeOfRecovery = (row["Place of Recovery"] || "").trim();
        if (!localityValidation(placeOfRecovery)) {
          errorMessages.push(`Row ${rowNo} : ${friendlyMessages.placeOfRecovery.empty}`);
          tableApi.selectCell(rowNo - 1, "Place of Recovery");
          mergeAllow = false;
        }
      }
      /* =========================
         SOFT WARNINGS (ALLOW MERGE)
         ========================= */

      // Sex - validate against dropdown options
      const sexKey = objectKeys.find(key => key === "Sex" || key === "Scx");
      if (sexKey) {
        const sexValue = ('' + row[sexKey]).trim();
        const validSexValues = ["", "Male", "Female", "Unknown"];
        if (sexValue && !validSexValues.includes(sexValue)) {
          errorMessages.push(`Row ${rowNo} : Sex "${sexValue}" is not a valid option. Allowed values: ${validSexValues.filter(v => v !== "").join(", ")}`);
          let sexCol = tableApi.propToCol(sexKey);
          if (sexCol === -1) sexCol = tableApi.propToCol("Sex");
          if (sexCol !== -1) tableApi.selectCell(rowNo - 1, sexCol);
          mergeAllow = false;
        } else if (!sexValidator(sexValue)) {
          warnUser = true;
        }
      }

      // Reported By
      if (objectKeys.includes("Reported By")) {
        if (!row["Reported By"] || digitsAndSpace(('' + row["Reported By"]).trim())) {
          warnUser = true;
        }
      }

      // Latitude
      if (objectKeys.includes("Latitude")) {
        if (digitsAndSpace(('' + row["Latitude"]).trim())) {
          warnUser = true;
        }
      }

      // Longitude
      if (objectKeys.includes("Longitude")) {
        if (digitsAndSpace(('' + row["Longitude"]).trim())) {
          warnUser = true;
        }
      }

      // Remarks
      if (objectKeys.includes("Remarks")) {
        if (digitsAndSpace(('' + row["Remarks"]).trim())) {
          warnUser = true;
        }
      }

      // QC Issues
      if (objectKeys.includes("QC Issues faced")) {
        if (digitsAndSpace(('' + row["QC Issues faced"]).trim())) {
          warnUser = true;
        }
      }
    }
  }
  return { mergeAllow, warnUser, errorMessages };
};

export { DataBaseValidationResighting };